import React, { Fragment } from 'react';
import BannerSection from './BannerSection';
import BannerSlider from './BannerSlider';
import CaseStudies from './CaseStudies';
import HireConfidence from './HireConfidence';
import FilterTalent from './FilterTalent';
import HighRiskFree from './HighRiskFree';
import EmoteEngineer from './EmoteEngineer';
import SimplifySection from '../common/SimplifySection';

const Onboarding = () => {

    return (
        <main className="text-white">
            <BannerSection />
            <CaseStudies />
            <HireConfidence />
            <FilterTalent />
            <HighRiskFree />
            <EmoteEngineer />
            <SimplifySection />
        </main>
    );
};

export default Onboarding;